export default __webpack_public_path__ + "static/media/mac_1.bc3b8530.jpg";